export function storeItem(key, value, obfuscate = true) {
  if (obfuscate) {
    value = obfuscateValue(value);
  }
  localStorage.setItem(key, value);
}

export function getItem(key, obfuscated = true) {
  let value = localStorage.getItem(key);
  if (obfuscated && value) {
    value = deobfuscateValue(value);
  }

  return value;
}

// Define a prefix to indicate obfuscation
const prefix = 'enc_';
const delimiters = ['|', '~', '^', '%', '&'];

function obfuscateValue(value, numberOfParts = 4) {
  // Reverse the value
  const reversedValue = value.split('').reverse().join('');
  const partSize = Math.ceil(reversedValue.length / numberOfParts);

  // Split the reversed value into the specified number of parts
  const parts = [];
  for (let i = 0; i < numberOfParts; i++) {
    parts.push(reversedValue.slice(i * partSize, (i + 1) * partSize));
  }

  // Join parts with different delimiters and add the prefix
  const obfuscatedValue = parts
    .map((part, index) => {
      const delimiter = delimiters[index % delimiters.length];
      return delimiter + part;
    })
    .join('');

  return prefix + obfuscatedValue;
}

function deobfuscateValue(obfuscatedValue) {
  // Check if the value has the correct prefix
  if (!obfuscatedValue.startsWith(prefix)) {
    throw new Error('Value format is incorrect or missing prefix.');
  }

  // Remove the prefix
  const valueWithoutPrefix = obfuscatedValue.slice(prefix.length);

  // Split parts using the delimiters
  let regexString = delimiters.map((d) => `\\${d}`).join('|');
  let regex = new RegExp(regexString, 'g');

  const parts = valueWithoutPrefix.split(regex).filter(Boolean);
  const reversedValue = parts.join('');
  const originalValue = reversedValue.split('').reverse().join('');

  return originalValue;
}

// test
// (token = localStorage.getItem('accessToken')), (otoken = obfuscate(token)), (dotoken = deobfuscate(otoken));
